/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Comparison_Missing_Weather_StationInputs */



/**
* | output |
* | --- |
* | "No weather station is linked to this building: choose one in its settings." |
*
* @param {Consumption_Comparison_Missing_Weather_StationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_comparison_missing_weather_station = /** @type {((inputs?: Consumption_Comparison_Missing_Weather_StationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Comparison_Missing_Weather_StationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("No weather station is linked to this building: choose one in its settings.")
	return /** @type {LocalizedString} */ ("Aucune station météo n'est associée à ce bâtiment : choisissez-la dans ses paramètres.")
});